import CryptoJS from "crypto-js";
import Logger from "./Logger";

class Utils {
  trimValue = (value) => {
    return typeof value === "string" ? value.trim() : value;
  };

  //check if window width reaches breaking point (responsive)
  checkWindowWidth = (setState, changeGoBackNavBar, flagButton, url) => {
    const windowSize = window.innerWidth;
    let flag = true;

    if (windowSize <= 1000) {
      flag = true;
    } else {
      flag = false;
    }

    this.checkGoBackNavBar(windowSize, changeGoBackNavBar, flagButton, url);

    setState({
      isMobileWidth: flag,
      width: windowSize,
    });
  };

  //Show back button from navbar in responsive view
  checkGoBackNavBar = (windowSize, propsCheckGoBackNavBar, flagButton, url) => {
    if (windowSize <= 1200) {
      propsCheckGoBackNavBar(flagButton, url);
    }
  };

  //generic handle input change
  handleChange = (event, setState) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    setState({
      [name]: value,
    });
  };

  handleChangeForInvalidAmount = (listCurrencies, listAmounts) => {
    console.log("handleChangeForInvalidAmount", listCurrencies, listAmounts);
    let invalidAmounts = [];
    for (let i = 0; i < listAmounts.length; i++) {
      if (
        !listCurrencies.some(
          (element) => element.base_currency == listAmounts[i].currency,
        ) ||
        Number(listAmounts[i].amount) >
          listCurrencies.filter(
            (element) => element.base_currency == listAmounts[i].currency,
          )[0].qty
      ) {
        invalidAmounts.push({
          currency: listAmounts[i].currency,
          amount: listCurrencies.some(
            (element) => element.base_currency == listAmounts[i].currency,
          )
            ? Number(
                listCurrencies.filter(
                  (element) => element.base_currency == listAmounts[i].currency,
                )[0].qty,
              ) - Number(listAmounts[i].amount)
            : Number(listAmounts[i].amount),
        });
      }
    }
    return invalidAmounts.length > 0 ? invalidAmounts : null;
  };

  getTokenFromStorage = () => {
    if (process.env.REACT_APP_ENV != "prod") {
      return localStorage.getItem("user");
    } else {
      return sessionStorage.getItem("user");
    }
  };

  //generic go back function
  goBack = (props) => {
    props.history.goBack();
  };

  editSearchTermDefault = (e, setState, list, listShowed, attributes) => {
    if (e.target.value != null && e.target.value != "") {
      setState({
        searchTerm: e.target.value,
        [listShowed]: this.filterFunction(list, attributes, e.target.value),
      });
    } else {
      setState({
        searchTerm: e.target.value,
        [listShowed]: list,
      });
    }
  };

  editSearchTermDefaultSearch = (e, setState, list, listShowed, attributes) => {
    if (e.target.value != null && e.target.value != "") {
      setState({
        [listShowed]: this.filterFunction(list, attributes, e.target.value),
      });
    } else {
      setState({
        [listShowed]: [],
      });
    }
  };

  filterFunction = (objects, attributes, value) => {
    var filteredObjects = [];
    var flagMatches = false;
    for (const i in objects) {
      flagMatches = false;
      for (const j in attributes) {
        if (objects[i][attributes[j]] != null) {
          // Handle both strings and numbers
          let valueToSearch;
          if (typeof objects[i][attributes[j]] === "number") {
            valueToSearch = objects[i][attributes[j]].toString();
          } else {
            valueToSearch = objects[i][attributes[j]].toString().toLowerCase();
          }

          if (valueToSearch.toLowerCase().includes(value.toLowerCase())) {
            flagMatches = true;
          }
        }
      }
      if (flagMatches) {
        filteredObjects.push(objects[i]);
      }
    }

    return filteredObjects;
  };

  formatDateUS = (dateISO) => {
    let newDate = null;
    if (dateISO != null) {
      const auxDate = new Date(dateISO);
      newDate = auxDate.toLocaleDateString("en-us");
    } else {
      newDate = "";
    }
    return newDate;
  };

  //format date to local timezone with time AM/PM, hence "en-US"
  formatDateUSWithTime = (dateISO) => {
    //console.log("formatDateUSWithTime input", dateISO);
    if (!dateISO) return "";

    // Remove microseconds (Safari only supports up to milliseconds)
    let fixedISO = dateISO.replace(/\.\d+/, "");

    // Replace "+00:00" with "Z" (Safari fails with colon in timezone offset)
    fixedISO = fixedISO.replace(/\+00:00$/, "Z");

    // If no timezone indicator, assume UTC and add 'Z'
    if (!fixedISO.endsWith("Z") && !fixedISO.match(/[+-]\d{2}:\d{2}$/)) {
      fixedISO += "Z";
    }

    const auxDate = new Date(fixedISO);

    //console.log("auxDate ", auxDate);
    //console.log("auxDate toLocaleString", auxDate.toLocaleString("en-US"));
    return isNaN(auxDate) ? "" : auxDate.toLocaleString("en-US");
  };

  formatDateToday = (dateISO, todayAtText) => {
    const formattedDate = this.formatDateUSWithTime(dateISO);
    if (!formattedDate) return "";

    const today = new Date().toLocaleDateString("en-US");
    const dateOnly = formattedDate.split(",")[0];

    return dateOnly === today
      ? formattedDate.replace(dateOnly + ",", todayAtText)
      : formattedDate;
  };

  formatDateReverse = (dateISO) => {
    if (!dateISO) return "";

    const auxDate = new Date(dateISO);
    const year = auxDate.getFullYear(); // changed from getUTCFullYear
    const month = String(auxDate.getMonth() + 1).padStart(2, "0"); // changed from getUTCMonth
    const day = String(auxDate.getDate()).padStart(2, "0"); // changed from getUTCDate

    return `${year}-${month}-${day}`;
  };

  orderAlphabetically = (array, key) => {
    if (Array.isArray(array) && array.length > 0) {
      array.sort((a, b) => {
        const valueA = a[key].toUpperCase(); // Convert to uppercase for case-insensitive sorting
        const valueB = b[key].toUpperCase();

        if (valueA < valueB) {
          return -1;
        } else if (valueA > valueB) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return array;
  };

  removeObjectDuplicates = (array, key) => {
    let lookup = {};
    array.forEach((element) => {
      lookup[element[key]] = element;
    });
    return Object.keys(lookup).map((key) => lookup[key]);
  };

  formatNumber(num, decimals) {
    /* Comma-grouped, no trailing zeros. The `decimals` argument caps
       the precision (maximumFractionDigits); minimumFractionDigits
       is pinned to 0 so 100.00 → "100", 100.50 → "100.5",
       1234.5678 (with decimals=2) → "1,234.57". This is the single
       source of truth for numeric display across the app —
       roundDecimals delegates here, so changing it propagates to
       every balance, fee, total, line item, and quote. */
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
    });
  }

  roundDecimals = (currency, value) => {
    if (value != null) {
      if (
        (currency != null &&
          currency != "" &&
          currency != "USD" &&
          currency != "USDT" &&
          currency != "USDC") ||
        (Number(value) < 1 && Number(value) > -1)
      ) {
        return this.formatNumber(value, 5);
      } else {
        return this.formatNumber(value, 2);
      }
    } else {
      return "";
    }
  };

  roundToXDecimals = (value, x) => {
    var numb = Number(value);
    numb = +numb.toFixed(x);
    //rounds only if neccesary
    return numb;
  };

  generatePDF = async (name, base64String, setState) => {
    try {
      // Decode the base64 string into a Uint8Array
      const pdfData = Uint8Array.from(atob(base64String), (c) =>
        c.charCodeAt(0),
      );

      // Load the PDF document
      const { PDFDocument } = await import("pdf-lib");
      const pdfDoc = await PDFDocument.load(pdfData);

      // Create a blob from the PDF document
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });

      // Create a link element and trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = name + ".pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Set the state to indicate the loading is complete
      setState({
        loadingDownload: false,
        pdfGeneratedSuccessfully: true,
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      setState({
        loadingDownload: false,
        pdfGeneratedSuccessfully: false,
      });
    }
  };

  generatePDFFromReceipt = async (name, setState) => {
    const { jsPDF } = await import("jspdf");
    const html2canvas = (await import("html2canvas")).default;
    const pdf = new jsPDF("portrait", "pt", "a4");
    const data = await html2canvas(document.querySelector("#pdf"), {
      scale: 1.5,
      onclone: function (clonedDoc) {
        clonedDoc.getElementById("hidden-div").style.display = "block";
      },
    }).then((canvas) => {
      const img = canvas.toDataURL("image/png");
      const imgProperties = pdf.getImageProperties(img);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
      pdf.addImage(img, "PNG", 0, 0, pdfWidth, pdfHeight);
      setState({
        loadingDownload: false,
      });
      pdf.save(name + ".pdf");
    });
  };

  goToURL = (props, url, megastate) => {
    console.log("props ", props);
    console.log("Pushing url: ", url);
    props.history.push({
      pathname: url,
      megastate: megastate ? megastate : null,
    });
  };

  getResultTitle = (success) => {
    if (success) {
      return "success";
    } else {
      return "something-went-wrong";
    }
  };

  interpolateText(text, values) {
    return text.replace(/%(\d+)/g, (match, index) => {
      const valueIndex = parseInt(index) - 1;
      return values[valueIndex] !== undefined ? values[valueIndex] : match;
    });
  }

  interpolateTextAsJSX = (template, variables, formatting = {}) => {
    if (!template || !variables) return template;

    // Split template by placeholders and build JSX
    const parts = [];
    let currentIndex = 0;

    if (Array.isArray(variables)) {
      variables.forEach((value, index) => {
        const placeholder = `%${index + 1}`;
        const placeholderIndex = template.indexOf(placeholder, currentIndex);

        if (placeholderIndex !== -1) {
          // Add text before placeholder
          if (placeholderIndex > currentIndex) {
            parts.push(template.substring(currentIndex, placeholderIndex));
          }

          // Add formatted variable
          if (formatting[index + 1] === "bold") {
            parts.push(<strong key={index}>{value}</strong>);
          } else {
            parts.push(value);
          }

          currentIndex = placeholderIndex + placeholder.length;
        }
      });

      // Add remaining text
      if (currentIndex < template.length) {
        parts.push(template.substring(currentIndex));
      }
    }

    return parts;
  };

  clearSession = (props, setConfig, setToken) => {
    //save persistent user preferences
    let rememberEmail = localStorage.getItem("remember-email") || "";
    let cardProfile = localStorage.getItem("blox_card_profile") || "";
    let hideTransactions = localStorage.getItem("hideRecentTransactions") || "";
    // Preserve KYC pending flags
    const kycPendingKeys = {};
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith("blox_kyc_pending_")) {
        kycPendingKeys[key] = localStorage.getItem(key);
      }
    });
    localStorage.clear();
    if (rememberEmail) localStorage.setItem("remember-email", rememberEmail);
    if (cardProfile) localStorage.setItem("blox_card_profile", cardProfile);
    if (hideTransactions) localStorage.setItem("hideRecentTransactions", hideTransactions);
    Object.entries(kycPendingKeys).forEach(([k, v]) => localStorage.setItem(k, v));

    //removes clientId and userId from logger
    Logger.clearSession();

    //setConfig and setToken will redirect to login
    setToken("");
    setConfig({});
  };

  conditionalPermission = (account, modules) => {
    return (
      process.env.REACT_APP_ENV == "local" ||
      (account &&
        account.roles &&
        account.roles.some(
          (role) => role.name && role.name.includes("Developer"),
        )) ||
      (account.permissions &&
        modules.some((module) =>
          account.permissions.some((permission) => permission.includes(module)),
        ))
    );
  };

  countPermittedModules = (account, modules) => {
    if (
      process.env.REACT_APP_ENV === "local" ||
      account?.roles?.some((role) => role.name?.includes("Developer"))
    ) {
      return modules.length;
    }

    let count = 0;

    if (account?.permissions) {
      count = modules.filter((module) =>
        account.permissions.some((permission) => permission.includes(module)),
      ).length;
    }

    console.log("Count", count);
    return count;
  };

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    const yOffset = -80;
    const y = section.getBoundingClientRect().top + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  exportToExcel = async (data) => {
    console.log("data being turned", data);
    const XLSX = await import("@e965/xlsx");
    // Convert array to worksheet
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write workbook to an ArrayBuffer
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Convert buffer to a Blob
    const excelBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Convert Blob to File (needed for FormData)
    return new File([excelBlob], "pay me list.xlsx", {
      type: excelBlob.type,
    });
  };

  getXAPIKey = () => {
    const xAPIKEY = process.env.REACT_APP_X_API_KEY;

    if (!xAPIKEY) {
      return null;
    }

    // If it doesn't contain a colon, it's a single API key
    if (!xAPIKEY.includes(":")) {
      return xAPIKEY;
    }

    // Handle multiple API keys format: pkbs:key1,pkbs2:key2
    const currentHostname = window.location.hostname;
    const apiKeyPairs = xAPIKEY.split(",");

    // Find the matching API key for the current hostname
    for (const pair of apiKeyPairs) {
      const [subdomain, key] = pair.split(":");
      if (subdomain && key && currentHostname == subdomain.trim()) {
        return key.trim();
      }
    }

    return null;
  };
}

export const utils = new Utils();
